/* stylelint-disable selector-max-compound-selectors */
:host {
    display: block;

    > div {
        position: relative;

        > .image-wrapper {
            overflow: hidden;
        }

        ::slotted(sew-picture) {
            display: block;
            width: 100%;
            transition: transform 0.2s ease;
        }

        ::slotted(iframe) {
            aspect-ratio: 16 / 9;
        }

        > p {
            @include typo-ws-paragraph-bold;

            background-color: $color-red;
            color: $color-white;
            left: 0;
            margin: 0;
            padding: 8px 16px;
            position: absolute;
            top: 0;
        }

        .video {
            @include video-play-button;
        }
    }

    > p {
        @include typo-ws-paragraph;

        margin: 12px 0 0;
    }

    ::slotted(a),
    ::slotted(button) {
        all: unset;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        cursor: pointer;
    }
}

:host(:hover) {
    ::slotted(sew-picture) {
        transform: scale(1.2);
    }

    > p {
        color: $color-red;
    }
}
